// extracted by mini-css-extract-plugin
export var pillWrapper = "_iq-0";
export var showOverflow = "_iq-1";